import axios from 'axios';
import { PostLoginResponse, BackendResponse, UploadFileResponse, SessionStatusResponse } from 'src/models';
import { REACT_APP_API_PLATFORM_URL } from '../util/config';

const api = axios.create({
  baseURL: REACT_APP_API_PLATFORM_URL,
  withCredentials: true,
});

export const postLogin = async (email: string, password: string, platformProvider = 'brickwise') => {
  return await api.post<BackendResponse<PostLoginResponse>>(
    '/auth/login',
    {
      email,
      password,
    },
    {
      headers: {
        partner_id: platformProvider,
      },
    },
  );
};

export const changePassword = async (passwordOld: string, passwordNew: string) => {
  return await api.patch('/auth/change-password', {
    passwordOld,
    passwordNew,
  });
};

export const forgotPassword = async (email: string, platformProvider = 'brickwise') => {
  return await api.post(
    '/auth/reset-password',
    {
      email,
    },
    {
      headers: {
        partner_id: platformProvider,
      },
    },
  );
};

export const resetPasswordFinish = async (token: string, passwordNew: string) => {
  return await api.post('/auth/reset-password/finish', {
    token,
    passwordNew,
  });
};

export const getSession = () => {
  return api.get<PostLoginResponse>('/auth/checkSession');
};

export const uploadFiles = (formData: FormData) => {
  return api.post<BackendResponse<UploadFileResponse>>('/api/v1/data/file', formData);
};

export const postLogout = async () => {
  return api.post('/auth/logout');
};

export const getSessionStatus = () => {
  return api.get<SessionStatusResponse>('/auth/checkSession');
};
